import { CircleNotch } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";
import Skeleton from "common/components/ui/Skeleton";

export default function AudioPlayerLoader() {
  return (
    <div className="mt-1 flex flex-row items-center gap-x-2">
      <Button intent="iconOnly" size="sm" disabled>
        <CircleNotch className="animate-spin" />
      </Button>

      <Skeleton className="h-2 w-[216px]" />

      <Skeleton className="h-4 w-8" />
    </div>
  );
}
